import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export default function CustomCursor() {
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const sx = useSpring(x, { stiffness: 500, damping: 45 });
  const sy = useSpring(y, { stiffness: 500, damping: 45 });
  const [active, setActive] = useState(false);

  useEffect(() => {
    const move = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
      setActive(!!e.target.closest("a,button,select,input,label"));
    };
    window.addEventListener("mousemove", move);
    return () => window.removeEventListener("mousemove", move);
  }, [x, y]);

  return (
    <motion.div
      aria-hidden
      className="hidden md:block fixed top-0 left-0 z-[90] pointer-events-none rounded-full border border-primary"
      style={{ x: sx, y: sy, translateX: "-50%", translateY: "-50%" }}
      animate={{ width: active ? 46 : 16, height: active ? 46 : 16, opacity: active ? 0.9 : 0.6 }}
      transition={{ duration: 0.2 }}
    />
  );
}
